import { useQuery } from '@apollo/client';
import { GET_ACTIVITY_FEED, type ActivityFeedItem } from './ActivityFeed.queries';

export function getVisibleActivityFeedItems(items: ActivityFeedItem[]) {
  return items
    .filter((notification) => !notification.dismissed)
    .slice()
    .sort((a, b) => {
      const followUpOrder = Number(!!b.followUp) - Number(!!a.followUp);
      if (followUpOrder !== 0) {
        return followUpOrder;
      }

      return new Date(b.time).getTime() - new Date(a.time).getTime();
    });
}

export default function useActivityFeed(limit = 25) {
  const query = useQuery(GET_ACTIVITY_FEED, {
    variables: { limit },
    notifyOnNetworkStatusChange: true,
  });

  const items: ActivityFeedItem[] = query.data?.activityFeed?.items ?? [];
  const visibleItems = getVisibleActivityFeedItems(items);

  return {
    ...query,
    items,
    visibleItems,
    hasUnread: visibleItems.some((notification) => !notification.read),
    hasFollowUp: visibleItems.some((notification) => !!notification.followUp),
  };
}
